module Meevo.Plugins.EmployeeSupplyUsage {
    import Variant = Meevo.Model.Variant;
    import EmployeeListItem = Meevo.Model.EmployeeListItem;

    class AdvancedFilterController {
        public selectedProduct: Variant;
        public selectedEmployee: EmployeeListItem;
        public employeeTypeAheadCriteria: Object;

        static $inject = [
            '$mdDialog',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
        ];

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService
        ) {}

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        }

        /**
         * Do search
         */
        public search(): void {
            this.$mdDialog.hide({
                selectedProduct: this.selectedProduct,
                selectedEmployee: this.selectedEmployee
            });
        }

        /**
         * Clear Form
         */
        public clear(): void {
            this.selectedProduct = null;
            this.selectedEmployee = null;
            this.search();
        }
    }

    angular.module('meevo.plugins.employeeSupplyUsage')
        .controller('meevo.plugins.employeeSupplyUsage.AdvancedFilterController', AdvancedFilterController);
}